import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for updating a space which is currently in the staging area.
 */

/**
 * Properties for the Confluence space creation command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by a bridge API client to update a space which is currently in the staging area.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to update a staging space with the specified content.
 */
export var ConfluenceSpaceUpdateCommand = createCommand('confluence-space-update-command');